enum DataGridToolBarFilterType {
	Search,
	DateRange,
	DeviceModel,
	DeviceState,
	LockState,
	Organisation,
	ResourceGroup,
	KeyType,
	UserRole,
}

export default DataGridToolBarFilterType;
